import React, { ReactNode } from 'react';
import { ConfigProvider } from 'antd';

type ThemeData = {
  borderRadius: number;
  colorPrimary: string;
  Button?: {
    colorPrimary: string;
    algorithm?: boolean;
  };
};

const coreTheme: ThemeData = {
  borderRadius: 2,
  colorPrimary: '#2c89c6',
};

interface StyleProviderProps {
  children: ReactNode;
}

export default function StyleProvider({ children }: StyleProviderProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: coreTheme.colorPrimary,
          borderRadius: coreTheme.borderRadius,
        },
        components: {
          Button: {
            colorPrimary: coreTheme.colorPrimary,
          }
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
